import '../../scss/components/paragraph.scss';
import BlueprintComponent from '../core/blueprintComponent';
/** The name of the module */
export const name = 'Paragraph';
/** The CSS classnames used by this module */
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-paragraph";
})(ClassNames || (ClassNames = {}));
class Paragraph extends BlueprintComponent {
    /**
       * Create a Paragraph HTML element
       *
       * @param content Content to display in the paragraph element
       */
    static createElement(content) {
        // Create the element and add the class name
        const element = document.createElement('p');
        element.classList.add(ClassNames.Default);
        // Add the content as a text node
        element.appendChild(document.createTextNode(content));
        return element;
    }
}
export default Paragraph;
